/*
 * @Author: Chao Yang
 * @Date: 2020-09-09 17:13:41
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-09-09 17:13:46
 */
export enum DateRangeTypeEnum {
  q1 = 1,
  q2,
  q3,
  q4,
  itd,
  ytd,
  custom,
}
